var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigator",style:({
    width: (_vm.size + "px"), height: (_vm.size + "px"),
    transform: ("translate(" + (_vm.x * _vm.size) + "px, " + (_vm.y * _vm.size) + "px)"),
    borderColor: ("var(--" + (_vm.removeMode ? 'primary' : 'main') + "-color)"),
    borderWidth: (_vm.borderWidth + "px")
  })})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751537b4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Logic/5Five/Sheet/Navigator.vue
// module id = null
// module chunks = 